(function () {
  const ORIGINAL_PRICE_PER_MONTH = 125; // One-time purchase price

  function parseDollars(str) {
    return parseFloat(str.replace(/[^0-9.]/g, ''));
  }

  function injectPricing() {
    const widget = document.querySelector('recharge-subscription-widget');
    if (!widget || !widget.shadowRoot) return;

    const upsell = widget.shadowRoot.querySelector('recharge-quantity-upsell');
    if (!upsell || !upsell.shadowRoot) return;

    const options = upsell.shadowRoot.querySelectorAll('.rc-quantity-upsell-option');
    if (!options.length) return;

    options.forEach((option) => {
      if (option.dataset.rcProcessed) return;

      const titleEl = option.querySelector('.rc-quantity-upsell-option__title');
      const headerEl = option.querySelector('.rc-quantity-upsell-option__header');

      if (!titleEl || !headerEl) return;

      const labelText = titleEl.textContent.trim();
      const monthMatch = labelText.match(/(\d+)\s*month/i);
      if (!monthMatch) return;

      const months = parseInt(monthMatch[1]);

      const priceEl = Array.from(headerEl.children).find(
        (el) => !el.classList.contains('rc-quantity-upsell-option__title-container')
      );

      if (!priceEl) return;

      const total = parseDollars(priceEl.textContent);
      if (!total) return;

      const perMonth = (total / months).toFixed(2);
      const originalTotal = ORIGINAL_PRICE_PER_MONTH * months;

      if (months === 1) {
        // 1 month: show $99/mo with $125 crossed out
        priceEl.innerHTML = `
          <div style="text-align:right;">
            <span style="display:block; font-weight:700; font-size:1em;">$${perMonth}<span style="font-size:0.75em; font-weight:400;">/mo</span></span>
            <span style="display:block; font-size:0.75em; color:#aaa; text-decoration:line-through;">$${ORIGINAL_PRICE_PER_MONTH.toFixed(2)}</span>
          </div>
        `;
      } else {
        // 3 and 6 month: show $X/mo, crossed out original total, discounted total
        priceEl.innerHTML = `
          <div style="text-align:right;">
            <span style="display:block; font-weight:700; font-size:1em;">$${perMonth}<span style="font-size:0.75em; font-weight:400;">/mo</span></span>
            <span style="display:block; font-size:0.75em;">
              <span style="color:#aaa; text-decoration:line-through;">$${originalTotal}</span>
              <span style="color:#000; margin-left:4px;">$${total}</span>
            </span>
          </div>
        `;
      }

      option.dataset.rcProcessed = 'true';
    });
  }

  let attempts = 0;
  const interval = setInterval(() => {
    attempts++;
    injectPricing();
    if (attempts > 20) clearInterval(interval);
  }, 500);

  document.addEventListener('DOMContentLoaded', injectPricing);
})();